import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { sparkleIcon } from '@/assets/icons';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type SparkleIconProps = Omit<AssetIconProps, 'src' | 'alt'>;

/** AI sparkle accent — AG purple (Icon.svg), HID blue (AIICON-BLUE-HID.svg). */
export function SparkleIcon({ size = 18, width, height, className, ...props }: SparkleIconProps) {
  const brandConfig = getBrandConfig();
  const resolvedSize = size ?? 18;

  if (APP_BRAND === 'hid' && brandConfig.hidAiBlueIcon) {
    const hidDimension = Math.round((resolvedSize * 13) / 18);
    return (
      <AssetIcon
        src={brandConfig.hidAiBlueIcon}
        width={width ?? hidDimension}
        height={height ?? hidDimension}
        className={className}
        alt=""
        aria-hidden
        {...props}
      />
    );
  }

  return (
    <AssetIcon
      src={sparkleIcon}
      width={width ?? resolvedSize}
      height={height ?? Math.round((resolvedSize * 17) / 18)}
      className={className}
      {...props}
    />
  );
}
